import textareaCounter from '../../4-component/textarea-counter/_index'
import vatinToggle from '../../4-component/user-registration-form/_index'
import clientTypeToggle from '../../4-component/user-registration-form/_client_type'
import ajaxRequest from 'utils/_ajax-request.js'
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'

const afterLoadForm = () => {
  //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})

  if( document.getElementsByTagName('textarea') ) {
    var a = document.getElementsByTagName('textarea');
    [...a].forEach((e) => {textareaCounter(e)})
    //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})
  }

  document.querySelectorAll('.form-field.--vatin > select').forEach((e) => {vatinToggle(e)})
  document.querySelectorAll('.form-field #user_edit_form_type').forEach((e) => {clientTypeToggle(e)})

  const saveUserButton = document.querySelector('#user_edit_form_save')

  if( saveUserButton ) {
    saveUserButton.addEventListener('click', (event)=>{
      let checkValidityRes = document.forms.user_edit_form.checkValidity()

      if( checkValidityRes ) {
        event.preventDefault();

        loadingWindowVisible('process', '#page-ajax')

        let openUrl = document.user_edit_form.getAttribute('action')
        let formData = new FormData(document.user_edit_form)

        ajaxRequest(
          (xhr, error) => {
            if( xhr.responseText == 'ok' ) {
              window.location.reload()
            }
            else {
              let pageAjax = document.getElementById('page-ajax')
              pageAjax.innerHTML = xhr.responseText
              pageAjax.classList.remove('-is-hidden')
              afterLoadForm()
              loadingWindowHandler('#page-ajax')
            }
          },
          (openUrl+'?ajax=1'),
          formData,
          'POST'
        )
      }

    })
  }
}

export default () => {
  //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})
  //document.querySelectorAll('.form-field.--vatin > select').forEach((e) => {vatinToggle(e)})

  afterLoadForm()
  loadingWindowHandler('#page-ajax')
}
